export default {
  "content": "<path d=\"M12 3a1 1 0 01.707.293l7.5 7.5-1.414 1.415L13 6.414V20h-2V6.415l-5.793 5.792-1.414-1.414 7.5-7.5.073-.066A1 1 0 0112 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};